// extracted by mini-css-extract-plugin
export default {"skipButton":"setup_skipButton__N22Ys"};